import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faTwitter,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <div className="footer">
      <div className="greet">若有需求可以提供給我，讓此看板更加精進</div>
      <div className="icon-group">
        <a
          href="https://twitter.com/f6233780"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon className='icon' icon={faTwitter} />
        </a>
        <a
          href="https://github.com/BradyYang-tw"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon className='icon' icon={faGithub} />
        </a>
        <a
          href="https://www.instagram.com/punk6233/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon className='icon' icon={faInstagram} />
        </a>
        <a
          href="https://www.linkedin.com/in/hsin-yu-yang-a9a590154/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon className='icon' icon={faLinkedin}/>
        </a>
      </div>
      <div className="CopyRight">
        BRADY INC. © COPYRIGHT 2022. ALL RIGHTS RESERVED.
      </div>
    </div>
  );
};

export default Footer;
